import type { MouseEventHandler, ReactNode } from 'react';
import { forwardRef } from 'react';

import { ButtonBase } from '../../../design/components/button/Defaults';

type OnboardingButtonProps = {
    readonly fullWidth?: boolean;
    readonly isDisabled?: boolean;
    readonly label: string;
    readonly onClick?: MouseEventHandler<HTMLButtonElement>;
    readonly startIcon?: ReactNode;
};

export const OnboardingButton = forwardRef<HTMLButtonElement, OnboardingButtonProps>((props, ref) => {
    const { fullWidth, isDisabled, label, onClick, startIcon } = props;

    return (
        <ButtonBase
            ref={ref}
            aria-label="Login"
            color="primary"
            fullWidth={fullWidth ?? false}
            isDisabled={isDisabled ?? false}
            startIcon={startIcon}
            variant="contained"
            onClick={onClick}
        >
            {label}
        </ButtonBase>
    );
});
